<!-- Componente generico para lineas temporales. Por el momento solo esta siendo usada en solicitudes -->
<template>
  <div>
    <v-container fluid>
      <v-row justify="space-around">
        <v-col cols="12" lg="6" class="my-2 pa-0">
          <v-card-text v-if="dLogs.length > 0">
            <v-timeline :dense="$vuetify.breakpoint.smAndDown">
              <v-timeline-item v-for="log in dLogs" :key="`${log.rn}`" 
                          :left="log.rn % 2 === 0" 
                          :right="log.rn % 2 !== 0" 
                          :color="fGetColorAction(log)" small>
                <v-card>
                  <v-card-text>
                    <p class="fs12 mb-0">{{fDateFormat(log.creationDate)}}</p>
                    <span class="fs14 fcC1 mb-0">{{log.title}}</span>
                    <p class="fs12 mb-0">{{log.userName}}</p>
                    <p class="fs12 mb-0">{{log.description}}</p>
                  </v-card-text>
                </v-card>
              </v-timeline-item>
            </v-timeline>
          </v-card-text>
          <v-card-text v-else>
            <p class="fs16 mb-0">{{$t('labels.noEvents')}}</p>
          </v-card-text>
        </v-col>
      </v-row> 
    </v-container> 
  </div>
</template>

<script>
import mxCanalDenuncias from '@/mixins/mxCanalDenuncias.vue'
import ServiceEcomplaints from '@/services/srv-eComplaints'
import ServiceEcomplaintsPublic from '@/services/srv-eComplaintsPublic'

export default {
  mixins: [mxCanalDenuncias],

  mounted(){
    this.fGetComplaintLogs()
  },

  props: {
    pComplaintInfo:{
      type: Object,
      required: false
    },
    pShowSnackbar:{
      type: String,
      default: 'BOTH' // SON PARENT BOTH
    },    
  },

  data () {
    return {
      dLogs: [],
      dExternalOrigin: localStorage.getItem("externOrigin") 
    }
  },

  methods: {
    //Muestra el historial de una denuncia 
    fGetComplaintLogs(){
      let payload = {
        complaintId: this.pComplaintInfo.complaintId
      }

      if (this.dExternalOrigin){
        ServiceEcomplaintsPublic.getComplaintLogs(payload).then(response => {
          if (response.statusCode == '200' && response.result != 'ko'){
            this.dLogs = response.dataRes
          }
        }).catch(error => {
          this.fSnackbarError(error, this.pShowSnackbar)
        })
      }else{
        ServiceEcomplaints.getComplaintLogs(payload).then(response => {
          if (response.statusCode == '200' && response.result != 'ko'){
            this.dLogs = response.dataRes
          }
        }).catch(error => {
          this.fSnackbarError(error, this.pShowSnackbar)
        })
      }       
    },
    
    fGetColorAction(log){
      if(log.rn % 2 === 0){
        return 'green'
      } else {
        return 'datPrimary' 
      }
    },

  }
}
</script>

